// Imports
import Vue from 'vue'
import Router from 'vue-router'
// import { trailingSlash } from '@/util/helpers'
import store from '../store'
import administratorRoutes from './routes/administrator'
import settings from './routes/settings/index'
import statisticsRoutes from './routes/statistics'
import directory from '@/router/routes/entities/index'
import knowledgeBaseRoutes from './routes/knowledge-base'
import billing from './routes/billing'
import administration from './routes/administration/index'
import support from './routes/support'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Главная',
      component: () => import('./../pages/Index.vue'),
      meta: {
        breadcrumb: 'Главная',
      },
    },
    {
      path: '/login',
      name: 'Вход',
      component: () => import('./../pages/Login.vue'),
      beforeEnter: (to, from, next) => {
        if (store.getters['auth/loggedIn']) {
          next('/')
        } else {
          next()
        }
      },
    },
    {
      path: '/logout',
      name: 'Выход',
      component: () => import('./../pages/Logout.vue'),
      beforeEnter: (to, from, next) => {
        if (store.getters['auth/loggedIn']) {
          next()
        } else next('/login')
      },
    },
    /**
     * Kitchen
     */
    {
      path: '/kitchen',
      name: 'Кухня',
      meta: { layout: 'kitchen-layout' },
      component: () => import('./../pages/Kitchen/Kitchen'),
    },
    /**
     * Справочники
     */
    /**
     * Entities: Orders
     */
    {
      path: '/orders',
      name: 'Заказы',
      component: () => import('./../pages/Directory/Orders'),
      meta: {
        permissions: ['crm.orders.view'],
        blockedByBilling: true,
      },
    },
    {
      path: '/new-order',
      name: 'newOrder',
      meta: {
        pageTitle: 'Новый заказ',
        needConfirmExit: true,
        permissions: ['crm.orders.view', 'crm.orders.edit'],
        layout: 'order-layout',
        blockedByBilling: true,
      },
      component: () => import('./../pages/Directory/NewOrder'),
    },
    {
      path: '/fast-order',
      name: 'fastOrderEdit',
      meta: {
        pageTitle: 'Заказ',
        blockedByBilling: true,
      },
      component: () => import('./../pages/Directory/FastOrder'),
    },
    {
      path: '/edit-order',
      name: 'orderEdit',
      meta: {
        pageTitle: 'Редактирование закза',
        layout: 'edit-order-layout',
        blockedByBilling: true,
      },
      component: () => import('./../pages/Directory/EditOrder'),
    },
    /**
     * Entities: Branches Settings
     */
    {
      path: '/settings/branches',
      name: 'Стандартные настройки филиалов',
      component: () => import('./../pages/Branches/Settings/Settings'),
    },
    {
      path: '/settings/branches/create',
      name: 'Создать настройку филиала',
      component: () => import('./../pages/Branches/Settings/SettingsCreate'),
    },
    {
      path: '/settings/branches/:id',
      name: 'Настройка филиала',
      component: () => import('./../pages/Branches/Settings/SettingsSingle'),
      props: { isEdit: false },
    },

    /**
     * Entities: Roles
     */
    {
      path: '/roles',
      name: 'Роли',
      component: () => import('./../pages/Roles/Roles'),
    },
    {
      path: '/roles/mutate',
      name: 'Создать роль',
      component: () => import('./../pages/Roles/RolesMutate'),
    },
    {
      path: '/roles/mutate/:id',
      name: 'Редактировать роль',
      component: () => import('./../pages/Roles/RolesMutate'),
    },
    /**
     * Entities: Clients
     */
    {
      path: '/clients',
      name: 'Клиенты',
      component: () => import('./../pages/Clients/Clients'),
    },
    {
      path: '/clients/create',
      name: 'Создать клиента',
      component: () => import('./../pages/Clients/ClientsCreate'),
    },
    {
      path: '/clients/:id',
      name: 'Клиент',
      component: () => import('./../pages/Clients/ClientsSingle'),
      props: { isEdit: false },
    },
    /**
     * Entities: Bundles
     */
    {
      path: '/bundles',
      name: 'Наборы',
      component: () => import('./../pages/Bundles/Bundles'),
    },
    {
      path: '/bundles/create',
      name: 'Создать набор',
      component: () => import('./../pages/Bundles/BundlesCreate'),
    },
    {
      path: '/bundles/:id',
      name: 'Набор',
      component: () => import('./../pages/Bundles/BundlesSingle'),
      props: { isEdit: false },
    },
    /**
     * Карта курьеров
     */
    {
      path: '/geo/couriers-map',
      name: 'couriers-map',
      component: () => import('./../pages/Geo/CouriersMap'),
      meta: {
        permissions: ['crm.couriers-map.view'],
        breadcrumb: {
          label: 'Карта курьеров',
          parent: 'Главная',
        },
      },
    },

    /**
     * Филиалы кол-центра
     */
    {
      path: '/call-center/filials',
      name: 'call-center-filials',
      component: () => import('./../pages/CallCenter/CallCenterFilials'),
      meta: {
        breadcrumb: {
          label: 'Филиалы кол-центра',
          parent: 'Главная',
        },
      },
    },

    /**
     * Стоп-лист
     */
    {
      path: '/stop-list',
      name: 'menu-items-stop-list',
      component: () => import('./../pages/StopList/StopListsPage.vue'),
      meta: {
        permissions: ['crm.stop-list.view'],
        breadcrumb: {
          label: 'Стоп-лист',
          parent: 'Главная',
        },
      },
    },

    /**
     * Меню филиалов
     */
    {
      path: '/filial-menu',
      name: 'filialMenuList',
      component: () => import('./../pages/FilialMenu/FilialMenuList'),
      meta: {
        permissions: ['crm.filial-menu.view'],
        breadcrumb: {
          label: 'Меню филиала',
          parent: 'Главная',
        },
      },
    },
    {
      path: '/filial-menu/edit',
      name: 'filialMenuEdit',
      component: () => import('./../pages/FilialMenu/FilialMenuEdit'),
      meta: {
        permissions: ['crm.filial-menu.view'],
        breadcrumb: {
          label: 'Изменение меню филиала',
          parent: 'filialMenuList',
        },
      },
    },
    {
      path: '/profile',
      name: 'profileEdit',
      component: () => import('./../pages/ProfileForm.vue'),
      meta: {
        breadcrumb: {
          label: 'Профиль',
          parent: 'Главная',
        },
      },
    },

    ...directory,
    ...administratorRoutes,
    ...settings,
    ...statisticsRoutes,
    ...knowledgeBaseRoutes,
    ...billing,
    ...administration,
    ...support,
  ],
})

// router.beforeEach((to, from, next) => {
//   return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
// })

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login' && !store.getters['auth/loggedIn']) {
    next('/login')
    return
  }

  if (from.meta.needConfirmExit || store.state.app.showConfirmBeforePageExit) {
    store.commit('app/setShowConfirmBeforePageExit', false)

    if (store.state.app.allowPageExitWithoutConfirm) {
      store.commit('app/setAllowPageExitWithoutConfirm', false)
      next()
      return
    }

    try {
      console.log('Show confirm from path:', from.path)
      await showExitConfirmDialog(from)
      next()
    } catch (error) {
      return false
    }
  }

  next()
})

// маршрут в сторе меняем только по состоявшемуся переходу: при «Отмена» в конфирме ухода
// страница остаётся прежней, а app/isNewOrderPage иначе начинал врать до перезагрузки
router.afterEach((to) => {
  store.commit('app/setCurrentRoute', to)
})

export default router

function showExitConfirmDialog (from) {
  const basket = store.state.baskets.basket
  const canCollapse = from && from.name === 'newOrder' && basket && basket.id

  if (canCollapse) {
    return new Promise((resolve, reject) => {
      store.dispatch('confirmDialog/show', {
        title: 'Уйти из оформления заказа?',
        content: 'Вы можете свернуть его и вернуться позже',
        cancelText: 'Отмена',
        confirmText: 'Закрыть заказ',
        confirmBtnColor: '#e91e63',
        extraText: 'Свернуть заказ',
        extraBtnColor: '#ff9100',
        extraIcon: 'mdi-chevron-double-down',
        onConfirm: () => {
          // «Закрыть заказ» = отказ от него: убираем и из свёрнутых, если он там был
          store.commit('collapsedOrders/remove', basket.id)
          resolve(true)
        },
        onExtra: () => {
          // Сворачиваем ДО resolve: beforeDestroy страницы заказа обнулит корзину в сторе
          store.dispatch('collapsedOrders/collapseCurrent')
          resolve(true)
        },
        onCancel: () => reject(new Error('User canceled')),
      })
    })
  }

  return new Promise((resolve, reject) => {
    store.dispatch('confirmDialog/show', {
      title: 'Вы действительно хотите покинуть страницу?',
      content: 'Все несохраненные данные будут потеряны',
      onConfirm: () => resolve(true),
      onCancel: () => reject(new Error('User canceled')),
    })
  })
}
